import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import { type APIResponse, type MatterLostWage } from "@/lib/types";

type MatterLostWageInput = Pick<MatterLostWage, "matterId"> &
  Partial<
    Pick<
      MatterLostWage,
      | "description"
      | "employed"
      | "positionRate"
      | "positionTitle"
      | "positionType"
      | "timeMissed"
    >
  >;

const lostWagePayloadKeys = [
  "description",
  "employed",
  "matterId",
  "positionRate",
  "positionTitle",
  "positionType",
  "timeMissed",
] as const;

const getMatterLostWagePayload = (data: MatterLostWageInput) =>
  Object.fromEntries(
    lostWagePayloadKeys
      .filter((key) => key in data)
      .map((key) => [key, data[key]]),
  ) as MatterLostWageInput;

export const createMatterLostWage = (data: MatterLostWageInput) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterLostWage>
    >(`${baseFastApiMatterRoute}/lost-wages`, getMatterLostWagePayload(data))
    .then((res) => res.data);
};

export const updateMatterLostWage = (
  data: MatterLostWageInput & Pick<MatterLostWage, "id" | "dateModified">,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<APIResponse<MatterLostWage>>(
      `${baseFastApiMatterRoute}/lost-wages`,
      {
        ...getMatterLostWagePayload(data),
        id: data.id,
        dateModified: data.dateModified,
      },
    )
    .then((res) => res.data);
};

export const deleteMatterLostWage = (
  data: Pick<MatterLostWage, "id" | "matterId">,
) => {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterLostWage>
    >(`${baseFastApiMatterRoute}/lost-wages/${data.id}`)
    .then((res) => res.data);
};
